import { Stack, Button, Typography, Card, Box } from "@material-ui/core";
import { UploadIllustration } from "assets";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useNatively } from "hooks/useNatively";
import type { Variants } from "framer-motion";
import type { MainCurrentPage } from "pages/dashboard/ImportLeadsPage";

export const variants: Variants = {
  initial: { opacity: 0, y: 25 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.4 } },
  exit: { opacity: 0, y: 25, transition: { duration: 0.4 } }
};

type MainImportContactsProps = {
  onCurrentPageChange: (targetPage: MainCurrentPage) => () => void;
};

export function MainImportContacts({ onCurrentPageChange }: MainImportContactsProps): JSX.Element {
  const { t: translate } = useTranslation();

  const { isNativeApp } = useNatively();

  return (
    <Stack gap={2}>
      <Typography noWrap variant="h4" sx={{ lineHeight: { xs: 2.5, md: 2 }, flexGrow: 1 }}>
        {translate("importContactsPage.mainContactsPage.title")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center"
        }}
        component={motion.div}
        {...variants}
      >
        <Card
          sx={{
            display: "flex",
            flexDirection: {
              xs: "column-reverse",
              md: "row"
            },
            maxWidth: 896,
            gap: {
              xs: 2,
              md: 4
            },
            p: 4
          }}
        >
          <Box sx={{ display: "grid", alignContent: "start", gap: 2 }}>
            <Typography variant="h3">
              {translate("importContactsPage.mainContactsPage.heading")}
            </Typography>
            <Typography sx={{ color: "text.secondary" }}>
              {translate("importContactsPage.mainContactsPage.description")}
            </Typography>
            <Stack direction="row" gap={2} flexWrap="wrap">
              <Button variant="contained" onClick={onCurrentPageChange("file")}>
                {translate("importContactsPage.mainContactsPage.fileButton")}
              </Button>
              <Button variant="contained" onClick={onCurrentPageChange("whatsapp")}>
                {translate("importContactsPage.mainContactsPage.whatsAppButton")}
              </Button>
              {isNativeApp && (
                <Button variant="contained" onClick={onCurrentPageChange("contacts")}>
                  {translate("importContactsPage.mainContactsPage.contactsButton")}
                </Button>
              )}
            </Stack>
          </Box>
          <UploadIllustration sx={{ flexShrink: 0, height: 240 }} />
        </Card>
      </Box>
    </Stack>
  );
}
